<template>
  <div>
    
    
    <h1>{{location}}</h1>
    <div v-if="!isLoading">
      
      <!-- {{ Object.keys(table[0])}} -->
      
      <!-- {{ keys }} -->
      
      <!-- {{table}} -->
      
      <BasicTableComponent 
        :list="store.subtotals(location)"
        tableClass="table2excel"
        :tableID="`${location}_Days`"
        :hideColumns="[ 'StartDateTime', 'EndDateTime', 'shiftsMediaTypes', 'shiftsMediaTypesCounts', 'shiftsJson', 'IDUsed']"
        :columnOrder="['day']"
        :formatters="{
          'day' : ['d', 'ddd MM/DD/YY'], 
          'Interac_#' :  ['n', '0,0'],
        }"
        :titles="{

        }"
        :totals="store.totals(location)"
      />

      <BasicTableComponent 
        :list="table" 
        tableClass="table2excel"
        :tableID="`${location}_Shifts`"
        :hideColumns="[ 'shiftsMediaTypes', 'shiftsMediaTypesCounts', 'shiftsJson', 'IDUsed']"
        :columnOrder="['day']"
        :formatters="{
          'day' : ['d', 'ddd MM/DD/YY'], 
          'StartDateTime' : ['d', 'h:mm a'],
          'EndDateTime' : ['d', 'h:mm a'],
          'Interac_#' :  ['n', '0,0'],
          
        }"
        :titles="{
          'StartDateTime' : 'Shift Start', 
          'EndDateTime' : 'Shift End', 
        }"
        :totals="store.totals(location)"
      />
    </div>
    
    
  </div>
</template>

<script>
export default {
  name: 'ReconcilliationTable',
  inject:['page'],
  props:['location', 'storeName'],
  methods:{
    
  },
  computed:{
    store(){return this.page.$refs[this.storeName]},
    timestamps(){ return this.store.timestamps},
    dateKey(){ return this.timestamps.dateKey},
    keys(){return this.$util.keys(this.table)},
    data(){
      return this.store.data && this.store.data[this.location] ? this.store.data[this.location].pos : undefined;
    },
    isLoading(){
      if(this.store.data[this.location] === undefined){
        return true;
      }
      return this.store.data[this.location].isLoading;
    },
    table(){
      if (this.isLoading){
        return;
      }
      // return this.store.pivotShifstMediaTypes(this.location);
      // return this.store.pivotShiftsMediaTypesCounts(this.location);
      // return this.store.shiftsWithTotals(this.location);
      return this.store.pivotedData[this.location].shifts;
    },

  },
}
</script>